// import { ExtractGraphRequest } from "@/layout/type";
import HttpClient from "../api/HttpClient";
import type { RequestOptions } from "../api/types";
import Utils from "@/utils";
import { FolderService } from "@/services/FolderService";


const headers = {
  "Content-Type": "application/json",
};
class GraphController {
  public Get = {
    getAllGraphs: (irai_id: string, options?: RequestOptions) => {

      const graphUrl = FolderService.getHost(FolderService.ApiHost)  + "/graph";
      return HttpClient.get(`${graphUrl}/${irai_id}/graphs`, options);
    },
    getAllNodes: (irai_id: string, options?: RequestOptions) => {
      const graphUrl = FolderService.getHost(FolderService.ApiHost)  + "/graph";
      return HttpClient.get(`${graphUrl}/${irai_id}/all-nodes`, options);
    },
    getNodesByGraphId: (graph_id: string, options?: RequestOptions) => {
      const graphUrl = FolderService.getHost(FolderService.ApiHost)  + "/graph";
      return HttpClient.get(`${graphUrl}/${graph_id}/nodes`, options);
    },
    getAllGraphsGuidFile: (guid_file: string, options?: RequestOptions) => {
      const graphUrl = FolderService.getHost(FolderService.ApiHost)  + "/graph";
      return HttpClient.get(
        `${graphUrl}/${guid_file}/graphs-guid-file`,
        options
      );
    },
  };
  public Post = {
    extractGraphByIraiId: (payload: any, options?: RequestOptions) => {
      const graphUrl = FolderService.getHost(FolderService.ApiHost)  + "/graph";
      return HttpClient.post(`${graphUrl}/extract-graph`, payload, {
        headers: headers,
        ...options,
      });
    },
    extractCellWindowByIraiId: (payload: any, options?: RequestOptions) => {
      const graphUrl = FolderService.getHost(FolderService.ApiHost)  + "/graph";
      return HttpClient.post(`${graphUrl}/extract-cell-window`, payload, {
        headers: headers,
        ...options,
      });
    },

    extractCordinatesWindowByIraiId:(payload:any,options?:RequestOptions)=>{
      const graphUrl = FolderService.getHost(FolderService.ApiHost)  + "/graph";
      return HttpClient.post(`${graphUrl}/extract-coordinate-window`,payload,{
        headers:headers,

        ...options,
      });
    },
  };
}

export const GraphService = new GraphController();
